import { cn } from '@/lib/utils';
import {
  ChangeDraftVm,
  DraftImpactEntryVm,
} from '@/features/dashboard/bookingChanges/types/ChangeViewModel.ts';
import MoneyAmountList from '@/features/dashboard/bookingChanges/components/primitives/MoneyAmountList.tsx';

const rowClass = 'flex items-baseline justify-between gap-3';

const ImpactRow = ({ entry }: { entry: DraftImpactEntryVm }) => (
  <div className={rowClass}>
    <span className="text-sm text-neutral-500">{entry.label}</span>
    <span
      className={cn(
        'whitespace-nowrap text-sm tabular-nums',
        entry.withoutImpact ? 'text-neutral-400' : 'font-semibold text-ink',
      )}
    >
      {entry.withoutImpact ? (
        'bez wpływu'
      ) : (
        <MoneyAmountList values={entry.delta} variant="signed" />
      )}
    </span>
  </div>
);

/** Wpływ szkicu osoba po osobie i wartość rezerwacji po zmianie. */
const ExitEditingImpact = ({ draft }: { draft: ChangeDraftVm }) => (
  <div className="flex flex-col gap-[11px] px-7 pb-2 pt-[18px]">
    {draft.impactByPerson.map((entry) => (
      <ImpactRow key={entry.personId} entry={entry} />
    ))}

    <div className={cn(rowClass, 'border-t border-neutral-100 pt-3')}>
      <span className="text-[15px] font-bold text-ink">
        Rezerwacja po zmianie
      </span>
      <span className="text-[15px] font-bold tabular-nums text-ink">
        <MoneyAmountList values={draft.bookingValueAfter} />
      </span>
    </div>
  </div>
);

export default ExitEditingImpact;
